(function() {
  'use strict';

  // [NUEVO] No buscar el grid todavía.
  let productGrid = null; 
  
  // [NUEVO] Prevenir que init() se llame múltiples veces
  // si el modal se abre y cierra.
  let isInitialized = false;
  
  // ============================================
  // ESTADO GLOBAL
  // ============================================

  let currentCartKeys = new Set();
  let isProcessing = false;
  let syncInterval = null;
  let lastKnownCartState = null;

  // ============================================
  // FUNCIONES CORE
  // ============================================

  function createCartKey(productId, option1Value) {
    const safeOption = String(option1Value ?? '').trim();
    return `${productId}-${safeOption}`;
  }

  function hideProductCard(card) {
    if (!card || card.style.display === 'none') return;
    card.style.display = 'none';
    card.classList.add('gemini-grid-item-in-cart');
  }

  function reviveProductCard(productId, option1Value) {
    const safeOption = String(option1Value ?? '').trim();
    // [NUEVO] Usar la variable 'productGrid' (que será asignada en init)
    const card = productGrid.querySelector(
      `.gemini-grid-item[data-product-id="${productId}"][data-option1-value="${safeOption}"]`
    );
    if (card && card.style.display === 'none') {
      card.style.display = '';
      card.classList.remove('gemini-grid-item-in-cart');
    }
  }

  function updateCounter(count) {
    document.querySelectorAll('.cart-count-bubble, #CartCount, [data-cart-count], .cart-link__count, .site-header__cart-count').forEach(el => {
      if (el && el.textContent !== String(count)) {
        el.textContent = count;
      }
    });
  }

  // ============================================
  // SYNC PERPETUO
  // ============================================

  async function syncWithCart() {
    if (isProcessing) return;
    isProcessing = true;

    try {
      const res = await fetch('/cart.js');
      if (!res.ok) throw new Error('Cart fetch failed');

      const cart = await res.json();
      const items = cart?.items || [];
      const currentState = JSON.stringify(items.map(i => ({ id: i.product_id, opt: i.options_with_values?.[0]?.value ?? null })));

      if (currentState === lastKnownCartState) {
        isProcessing = false;
        return;
      }

      lastKnownCartState = currentState;
      const newKeys = new Set();
      items.forEach(item => {
        const optValue = item.options_with_values?.[0]?.value;
        newKeys.add(createCartKey(item.product_id, optValue));
      });

      const toRemove = [...currentCartKeys].filter(key => !newKeys.has(key));
      const toAdd = [...newKeys].filter(key => !currentCartKeys.has(key));

      if (toRemove.length > 0 || toAdd.length > 0) {
        toRemove.forEach(key => {
          const [pid, opt] = key.split(/-(.*)/);
          if (pid) reviveProductCard(pid, opt);
        });

        toAdd.forEach(key => {
          const [pid, opt] = key.split(/-(.*)/);
          if (!pid) return;
          const safeOption = String(opt ?? '').trim();
          // [NUEVO] Usar la variable 'productGrid'
          const card = productGrid.querySelector(
            `.gemini-grid-item[data-product-id="${pid}"][data-option1-value="${safeOption}"]`
          );
          if (card) hideProductCard(card);
        });
        console.log(`🔄 Synced: +${toAdd.length} added, -${toRemove.length} removed`);
      }
      currentCartKeys = newKeys;
      updateCounter(cart.item_count || 0);
    } catch (e) {
      console.warn('Sync error:', e);
    } finally {
      isProcessing = false;
    }
  }

  // ============================================
  // DISPARAR EVENTOS
  // ============================================

  function triggerCartEvents(cartData) {
    ['cart:updated', 'cart:refresh'].forEach(eventName => {
      try {
        const event = new CustomEvent(eventName, {
          detail: { cart: cartData },
          bubbles: true,
          composed: true
        });
        document.dispatchEvent(event);
        document.body.dispatchEvent(event);
      } catch (e) {
        console.warn(`Error triggering event ${eventName}:`, e);
      }
    });
  }

  // ============================================
  // ADD TO CART
  // ============================================

  async function handleAddToCart(e) {
    e.preventDefault();
    e.stopPropagation();

    const btn = e.currentTarget;
    if (btn.disabled || btn.dataset.busy === 'true') return;

    btn.dataset.busy = 'true';
    const originalText = btn.textContent;
    btn.textContent = 'Añadiendo...';
    btn.disabled = true;

    const form = btn.closest('form');
    const card = btn.closest('.gemini-grid-item');

    if (!form || !card) {
      console.error('ATC Error: No se encontró <form> o .gemini-grid-item parent.');
      btn.textContent = originalText;
      btn.disabled = false;
      delete btn.dataset.busy;
      return;
    }

    const variantSelect = form.querySelector('select[name="id"]');
    const variantInput = variantSelect || form.querySelector('input[name="id"]');

    if (!variantInput || !variantInput.value) {
      console.error('ATC Error: No se pudo encontrar el variant ID input.', form);
      alert('Error: No se pudo encontrar la variante del producto.');
      btn.textContent = originalText;
      btn.disabled = false;
      delete btn.dataset.busy;
      return;
    }

    const variantId = variantInput.value;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        headers: { 'Content-Type': 'application/json' }
      });

      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.description || 'Error al añadir al carrito');
      }

      hideProductCard(card);
      const cartData = await fetch('/cart.js').then(r => r.json());
      updateCounter(cartData.item_count || 0);
      triggerCartEvents(cartData);

      setTimeout(() => {
        const drawer = document.querySelector('cart-drawer');
        if (drawer?.show) drawer.show();
      }, 150);

      setTimeout(() => syncWithCart(), 200);
      console.log('✅ Added to cart');

    } catch (err) {
      console.error('❌ Error:', err);
      const pid = card.dataset.productId;
      const opt = card.dataset.option1Value;
      if (pid && opt) {
        reviveProductCard(pid, opt);
      } else {
        card.style.display = '';
        card.classList.remove('gemini-grid-item-in-cart');
      }
      alert(err.message);
    } finally {
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
        delete btn.dataset.busy;
      }, 600);
    }
  }

  // ============================================
  // ATTACH LISTENERS
  // ============================================

  function attachListeners() {
    // [NUEVO] Usar la variable 'productGrid'
    productGrid.querySelectorAll('.gemini-grid-atc-button').forEach(btn => {
      if (btn.dataset.hasListener) return;
      btn.dataset.hasListener = 'true';
      btn.addEventListener('click', handleAddToCart);
    });
  }

  // ============================================
  // REMOVE HANDLER
  // ============================================

  document.body.addEventListener('click', function(e) {
    const removeLink = e.target.closest('a[href*="/cart/change"]');
    if (!removeLink?.closest('cart-drawer')) return;
    console.log('🗑️ Remove detected');
    setTimeout(() => syncWithCart(), 400);
    setTimeout(() => syncWithCart(), 800);
  }, true);

  // ============================================
  // DRAWER MUTATION OBSERVER
  // ============================================

  let drawerObserver; 

  function startObserving() {
    if (drawerObserver) drawerObserver.disconnect();
    
    drawerObserver = new MutationObserver(function(mutations) {
      let shouldSync = false;
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
          const relevantChange = Array.from(mutation.addedNodes).some(n => n.classList?.contains('cart-item')) ||
                                 Array.from(mutation.removedNodes).some(n => n.classList?.contains('cart-item'));
          if (relevantChange) {
            shouldSync = true;
            break; 
          }
        }
      }
      if (shouldSync) {
        console.log('👀 Drawer changed, syncing...');
        setTimeout(() => syncWithCart(), 100);
      }
    });

    const drawer = document.querySelector('cart-drawer');
    const drawerContainer = drawer || document.getElementById('CartDrawer');
    
    if (drawerContainer) {
      drawerObserver.observe(drawerContainer, {
        childList: true,
        subtree: true,
      });
      console.log('👁️ Drawer observer active');
    } else {
      console.warn('Gemini Sync: No se encontró cart-drawer para observar.');
    }
  }

  // ============================================
  // META-OBSERVER (REEMPLAZO DEL DRAWER)
  // ============================================

  const bodyObserver = new MutationObserver(function(mutations) {
    let drawerAdded = false;
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1 && (node.matches('cart-drawer, #CartDrawer') || node.querySelector('cart-drawer, #CartDrawer'))) {
            drawerAdded = true;
            break;
          }
        }
      }
      if (drawerAdded) break;
    }

    if (drawerAdded) {
      console.log('🔄 Drawer element re-added. Re-initializing drawer observer.');
      setTimeout(startObserving, 100); 
    }
  });

  // ============================================
  // ESCUCHAR EVENTOS GLOBALES
  // ============================================

  ['cart:updated', 'cart:refresh', 'cart:build'].forEach(eventName => {
    document.addEventListener(eventName, function(e) {
      console.log('📢', eventName, e.detail);
      setTimeout(() => syncWithCart(), 100);
    });
  });

  // ============================================
  // HEARTBEAT
  // ============================================

  function startHeartbeat() {
    if (syncInterval) clearInterval(syncInterval);
    syncInterval = setInterval(() => {
      if (!isProcessing && document.visibilityState === 'visible') {
        setTimeout(syncWithCart, 150);
      }
    }, 2500);
    console.log('💓 Heartbeat started (2.5s interval)');
  }

  // ============================================
  // GRID OBSERVER (FILTROS, ETC.)
  // ============================================
  
  // [NUEVO] Mover el gridObserver aquí para que esté definido antes de init
  const gridObserver = new MutationObserver(function(mutations) {
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // [NUEVO] Usar la variable 'productGrid'
        const newButtons = productGrid.querySelectorAll('.gemini-grid-atc-button:not([data-has-listener])');
        if (newButtons.length > 0) {
          console.log(`🔌 Attaching listeners to ${newButtons.length} new buttons.`);
          attachListeners();
        }
      }
    }
  });


  // ============================================
  // INICIALIZACIÓN
  // ============================================

  function init() {
    // [NUEVO] Esta función ahora es llamada por el 'gridAppearsObserver'
    // y solo cuando 'productGrid' existe.
    
    if (isInitialized) {
        console.log('Script ya inicializado. Refrescando listeners.');
        // Si el modal se re-abre, solo refrescar listeners y sync
        attachListeners();
        syncWithCart();
        return;
    }
    
    isInitialized = true; // Marcar como inicializado
    window.geminiCartInitialized = true; // Marcar globalmente

    console.log('🚀 Gemini Grid Auto-Sync initialized');
    syncWithCart();
    attachListeners();
    startObserving();
    startHeartbeat();
    
    // Inicia el meta-observador para vigilar reemplazos del drawer
    bodyObserver.observe(document.body, { childList: true, subtree: true });

    // Inicia el observador del grid (para filtros, etc.)
    // [NUEVO] Usar la variable 'productGrid'
    gridObserver.observe(productGrid, {
      childList: true,
      subtree: true
    });

    console.log('✅ All systems operational');
  }
  
  // ============================================
  // [NUEVO] OBSERVADOR MAESTRO (EL ARREGLO)
  // ============================================

  // Este observador vigila el <body>
  const gridAppearsObserver = new MutationObserver((mutations, observer) => {
    // Intentar encontrar el grid
    const grid = document.getElementById("gemini-product-grid");

    if (grid) {
      // ¡Lo encontramos!
      console.log('👁️ Grid (#gemini-product-grid) detectado. Iniciando script.');
      
      // Asignar el grid a nuestra variable global
      productGrid = grid; 
      
      // Llamar a init()
      init();
      
      // [OPCIONAL PERO RECOMENDADO]
      // Si el grid NUNCA se elimina y recrea (solo el modal),
      // podemos desconectar este observador maestro para ahorrar recursos.
      // Si el modal se destruye y recrea CADA VEZ, comenta la línea de abajo.
      // observer.disconnect(); 
      
    } else if (isInitialized) {
        // Si el script ya se inicializó pero el grid desapareció
        // (ej. se cerró el modal y se eliminó del DOM)
        console.log('Grid desaparecido. Reseteando flag de inicialización.');
        isInitialized = false; 
        productGrid = null;
        // El observador seguirá activo, esperando a que vuelva a aparecer.
    }
  });

  // Empezar a observar el <body>
  gridAppearsObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  console.log('🔍 Gemini Sync: Esperando a que #gemini-product-grid aparezca...');


  // ============================================
  // CLEANUP
  // ============================================

  window.addEventListener('beforeunload', () => {
    if (syncInterval) clearInterval(syncInterval);
    if (drawerObserver) drawerObserver.disconnect();
    if (gridObserver) gridObserver.disconnect();
    if (bodyObserver) bodyObserver.disconnect();
    // [NUEVO] Limpiar el observador maestro
    if (gridAppearsObserver) gridAppearsObserver.disconnect();
  });

  // [ELIMINADO] No llamar a init() al cargar la página.
  // if (document.readyState === 'loading') { ... } else { init(); }

})();